import { PoweredByEndear } from "../components/PoweredByEndear";
import { FeedLogo } from "../components/feed/FeedLogo";
import { FeedSection } from "../components/feed/FeedSection";
import { FeedTitle } from "../components/feed/FeedTitle";
import type { SectionWithCheckoutProducts } from "../hooks/use-items-with-checkout";
import type { LookbookProps } from "../lookbook";

export interface FeedViewProps extends LookbookProps {
  sections: SectionWithCheckoutProducts[];
}

export function FeedView(props: FeedViewProps) {
  const { logo, lookbook, showBranding, sections, checkout } = props;

  return (
    <div className="feed-view">
      {logo.url.length ? (
        <FeedLogo logo={logo} checkoutEnabled={checkout.enabled} />
      ) : null}
      {lookbook.title.length ||
      lookbook.creator?.first_name?.length ||
      lookbook.description.length ? (
        <FeedTitle
          title={lookbook.title}
          creator={lookbook.creator?.first_name}
          description={lookbook.description}
        />
      ) : null}
      {sections.map((section) => (
        <FeedSection key={section.id} section={section} />
      ))}
      <div className="py-12 flex items-center justify-center">
        {showBranding ? (
          <PoweredByEndear className="p-2 -ml-2 bg-white" />
        ) : null}
      </div>
    </div>
  );
}
